module.exports = [
	{
		"latLng": [
			48.20849,
			16.37208
		],
		"name": "Vienna"
	},
	{
		"latLng": [
			47.06667,
			15.45
		],
		"name": "Graz"
	},
	{
		"latLng": [
			51.05,
			3.71667
		],
		"name": "Gent"
	},
	{
		"latLng": [
			50.41136,
			4.44448
		],
		"name": "Charleroi"
	},
	{
		"latLng": [
			50.85045,
			4.34878
		],
		"name": "Brussels"
	},
	{
		"latLng": [
			51.21989,
			4.40346
		],
		"name": "Antwerpen"
	},
	{
		"latLng": [
			43.21667,
			27.91667
		],
		"name": "Varna"
	},
	{
		"latLng": [
			42.69751,
			23.32415
		],
		"name": "Sofia"
	},
	{
		"latLng": [
			42.15,
			24.75
		],
		"name": "Plovdiv"
	},
	{
		"latLng": [
			43.68341,
			-79.76633
		],
		"name": "Brampton"
	},
	{
		"latLng": [
			49.26636,
			-122.95263
		],
		"name": "Burnaby"
	},
	{
		"latLng": [
			51.05011,
			-114.08529
		],
		"name": "Calgary"
	},
	{
		"latLng": [
			53.55014,
			-113.46871
		],
		"name": "Edmonton"
	},
	{
		"latLng": [
			43.65421,
			-79.56711
		],
		"name": "Etobicoke"
	},
	{
		"latLng": [
			45.47723,
			-75.70164
		],
		"name": "Gatineau"
	},
	{
		"latLng": [
			43.25011,
			-79.84963
		],
		"name": "Hamilton"
	},
	{
		"latLng": [
			43.42537,
			-80.5112
		],
		"name": "Kitchener"
	},
	{
		"latLng": [
			45.56995,
			-73.692
		],
		"name": "Laval"
	},
	{
		"latLng": [
			42.98339,
			-81.23304
		],
		"name": "London"
	},
	{
		"latLng": [
			45.53121,
			-73.51806
		],
		"name": "Longueuil"
	},
	{
		"latLng": [
			43.86682,
			-79.2663
		],
		"name": "Markham"
	},
	{
		"latLng": [
			43.5789,
			-79.6583
		],
		"name": "Mississauga"
	},
	{
		"latLng": [
			45.50884,
			-73.58781
		],
		"name": "Montréal"
	},
	{
		"latLng": [
			43.76681,
			-79.4163
		],
		"name": "North York"
	},
	{
		"latLng": [
			43.90012,
			-78.84957
		],
		"name": "Oshawa"
	},
	{
		"latLng": [
			45.41117,
			-75.69812
		],
		"name": "Ottawa"
	},
	{
		"latLng": [
			49.10635,
			-122.82509
		],
		"name": "Surrey"
	},
	{
		"latLng": [
			43.70011,
			-79.4163
		],
		"name": "Toronto"
	},
	{
		"latLng": [
			49.24966,
			-123.11934
		],
		"name": "Vancouver"
	},
	{
		"latLng": [
			43.8361,
			-79.49827
		],
		"name": "Vaughan"
	},
	{
		"latLng": [
			48.43294,
			-123.3693
		],
		"name": "Victoria"
	},
	{
		"latLng": [
			42.30008,
			-83.01654
		],
		"name": "Windsor"
	},
	{
		"latLng": [
			49.8844,
			-97.14704
		],
		"name": "Winnipeg"
	},
	{
		"latLng": [
			44.64533,
			-63.57239
		],
		"name": "Halifax"
	},
	{
		"latLng": [
			46.81228,
			-71.21454
		],
		"name": "Québec"
	},
	{
		"latLng": [
			43.77223,
			-79.25666
		],
		"name": "Scarborough"
	},
	{
		"latLng": [
			50.36386,
			-119.34997
		],
		"name": "Okanagan"
	},
	{
		"latLng": [
			35.17531,
			33.3642
		],
		"name": "Nicosia"
	},
	{
		"latLng": [
			50.08804,
			14.42076
		],
		"name": "Prague"
	},
	{
		"latLng": [
			49.83465,
			18.28204
		],
		"name": "Ostrava"
	},
	{
		"latLng": [
			49.19522,
			16.60796
		],
		"name": "Brno"
	},
	{
		"latLng": [
			51.27027,
			7.16755
		],
		"name": "Wuppertal"
	},
	{
		"latLng": [
			50.08258,
			8.24932
		],
		"name": "Wiesbaden"
	},
	{
		"latLng": [
			48.78232,
			9.17702
		],
		"name": "Stuttgart"
	},
	{
		"latLng": [
			51.47805,
			6.8625
		],
		"name": "Oberhausen"
	},
	{
		"latLng": [
			49.45421,
			11.07752
		],
		"name": "Nürnberg"
	},
	{
		"latLng": [
			52.15,
			11.63333
		],
		"name": "Neue Neustadt"
	},
	{
		"latLng": [
			51.96236,
			7.62571
		],
		"name": "Münster"
	},
	{
		"latLng": [
			48.13743,
			11.57549
		],
		"name": "Munich"
	},
	{
		"latLng": [
			51.18539,
			6.44172
		],
		"name": "Mönchengladbach"
	},
	{
		"latLng": [
			49.4891,
			8.46694
		],
		"name": "Mannheim"
	},
	{
		"latLng": [
			52.12773,
			11.62916
		],
		"name": "Magdeburg"
	},
	{
		"latLng": [
			53.86893,
			10.68729
		],
		"name": "Lübeck"
	},
	{
		"latLng": [
			51.33962,
			12.37129
		],
		"name": "Leipzig"
	},
	{
		"latLng": [
			51.33645,
			6.55381
		],
		"name": "Krefeld"
	},
	{
		"latLng": [
			50.93333,
			6.95
		],
		"name": "Köln"
	},
	{
		"latLng": [
			54.32133,
			10.13489
		],
		"name": "Kiel"
	},
	{
		"latLng": [
			49.00937,
			8.40444
		],
		"name": "Karlsruhe"
	},
	{
		"latLng": [
			53.46057,
			9.98388
		],
		"name": "Harburg"
	},
	{
		"latLng": [
			52.37052,
			9.73322
		],
		"name": "Hannover"
	},
	{
		"latLng": [
			53.58334,
			10.08305
		],
		"name": "Wandsbek"
	},
	{
		"latLng": [
			53.56667,
			10.08333
		],
		"name": "Marienthal"
	},
	{
		"latLng": [
			53.55,
			10.01667
		],
		"name": "Hamburg-Mitte"
	},
	{
		"latLng": [
			53.56667,
			9.98333
		],
		"name": "Eimsbüttel"
	},
	{
		"latLng": [
			53.55,
			9.93333
		],
		"name": "Altona"
	},
	{
		"latLng": [
			53.57532,
			10.01534
		],
		"name": "Hamburg"
	},
	{
		"latLng": [
			51.48158,
			11.97947
		],
		"name": "Halle (Saale)"
	},
	{
		"latLng": [
			51.50508,
			7.09654
		],
		"name": "Gelsenkirchen"
	},
	{
		"latLng": [
			47.9959,
			7.85222
		],
		"name": "Freiburg"
	},
	{
		"latLng": [
			50.11552,
			8.68417
		],
		"name": "Frankfurt am Main"
	},
	{
		"latLng": [
			51.45657,
			7.01228
		],
		"name": "Essen"
	},
	{
		"latLng": [
			50.9787,
			11.03283
		],
		"name": "Erfurt"
	},
	{
		"latLng": [
			51.22172,
			6.77616
		],
		"name": "Düsseldorf"
	},
	{
		"latLng": [
			51.43247,
			6.76516
		],
		"name": "Duisburg"
	},
	{
		"latLng": [
			51.05089,
			13.73832
		],
		"name": "Dresden"
	},
	{
		"latLng": [
			51.51494,
			7.466
		],
		"name": "Dortmund"
	},
	{
		"latLng": [
			50.8357,
			12.92922
		],
		"name": "Chemnitz"
	},
	{
		"latLng": [
			53.07516,
			8.80777
		],
		"name": "Bremen"
	},
	{
		"latLng": [
			52.26594,
			10.52673
		],
		"name": "Braunschweig"
	},
	{
		"latLng": [
			50.73438,
			7.09549
		],
		"name": "Bonn"
	},
	{
		"latLng": [
			51.48165,
			7.21648
		],
		"name": "Bochum"
	},
	{
		"latLng": [
			52.03333,
			8.53333
		],
		"name": "Bielefeld"
	},
	{
		"latLng": [
			52.52437,
			13.41053
		],
		"name": "Berlin"
	},
	{
		"latLng": [
			48.37154,
			10.89851
		],
		"name": "Augsburg"
	},
	{
		"latLng": [
			50.77664,
			6.08342
		],
		"name": "Aachen"
	},
	{
		"latLng": [
			51.50168,
			7.1756
		],
		"name": "Bochum-Hordel"
	},
	{
		"latLng": [
			53.58935,
			9.984
		],
		"name": "Hamburg-Nord"
	},
	{
		"latLng": [
			55.67594,
			12.56553
		],
		"name": "Copenhagen"
	},
	{
		"latLng": [
			56.15674,
			10.21076
		],
		"name": "Århus"
	},
	{
		"latLng": [
			59.43696,
			24.75353
		],
		"name": "Tallinn"
	},
	{
		"latLng": [
			39.46975,
			-0.37739
		],
		"name": "Valencia"
	},
	{
		"latLng": [
			37.38283,
			-5.97317
		],
		"name": "Sevilla"
	},
	{
		"latLng": [
			28.46824,
			-16.25462
		],
		"name": "Santa Cruz de Tenerife"
	},
	{
		"latLng": [
			39.56939,
			2.65024
		],
		"name": "Palma"
	},
	{
		"latLng": [
			37.98704,
			-1.13004
		],
		"name": "Murcia"
	},
	{
		"latLng": [
			36.72016,
			-4.42034
		],
		"name": "Málaga"
	},
	{
		"latLng": [
			28.09973,
			-15.41343
		],
		"name": "Las Palmas de Gran Canaria"
	},
	{
		"latLng": [
			36.68645,
			-6.13606
		],
		"name": "Jerez de la Frontera"
	},
	{
		"latLng": [
			37.18817,
			-3.60667
		],
		"name": "Granada"
	},
	{
		"latLng": [
			38.26218,
			-0.70107
		],
		"name": "Elche"
	},
	{
		"latLng": [
			37.89155,
			-4.77275
		],
		"name": "Córdoba"
	},
	{
		"latLng": [
			37.60512,
			-0.98623
		],
		"name": "Cartagena"
	},
	{
		"latLng": [
			38.34517,
			-0.48149
		],
		"name": "Alicante"
	},
	{
		"latLng": [
			41.65606,
			-0.87734
		],
		"name": "Zaragoza"
	},
	{
		"latLng": [
			42.84998,
			-2.67268
		],
		"name": "Gasteiz / Vitoria"
	},
	{
		"latLng": [
			42.23282,
			-8.72264
		],
		"name": "Vigo"
	},
	{
		"latLng": [
			41.65518,
			-4.72372
		],
		"name": "Valladolid"
	},
	{
		"latLng": [
			41.56667,
			2.01667
		],
		"name": "Terrassa"
	},
	{
		"latLng": [
			41.54329,
			2.10942
		],
		"name": "Sabadell"
	},
	{
		"latLng": [
			40.39354,
			-3.662
		],
		"name": "Puente de Vallecas"
	},
	{
		"latLng": [
			43.36029,
			-5.84476
		],
		"name": "Oviedo"
	},
	{
		"latLng": [
			40.32234,
			-3.86496
		],
		"name": "Móstoles"
	},
	{
		"latLng": [
			40.4165,
			-3.70256
		],
		"name": "Madrid"
	},
	{
		"latLng": [
			43.37135,
			-8.396
		],
		"name": "A Coruña"
	},
	{
		"latLng": [
			41.35967,
			2.10028
		],
		"name": "L'Hospitalet de Llobregat"
	},
	{
		"latLng": [
			43.53573,
			-5.66152
		],
		"name": "Gijón"
	},
	{
		"latLng": [
			40.44505,
			-3.65132
		],
		"name": "Ciudad Lineal"
	},
	{
		"latLng": [
			43.26271,
			-2.92528
		],
		"name": "Bilbao"
	},
	{
		"latLng": [
			41.38879,
			2.15899
		],
		"name": "Barcelona"
	},
	{
		"latLng": [
			41.45004,
			2.24741
		],
		"name": "Badalona"
	},
	{
		"latLng": [
			40.48205,
			-3.35996
		],
		"name": "Alcalá de Henares"
	},
	{
		"latLng": [
			41.38896,
			2.16179
		],
		"name": "Eixample"
	},
	{
		"latLng": [
			41.41814,
			2.19933
		],
		"name": "Sant Martí"
	},
	{
		"latLng": [
			40.38897,
			-3.74569
		],
		"name": "Latina"
	},
	{
		"latLng": [
			40.39094,
			-3.7242
		],
		"name": "Carabanchel"
	},
	{
		"latLng": [
			40.4984,
			-3.7314
		],
		"name": "Fuencarral-El Pardo"
	},
	{
		"latLng": [
			61.49911,
			23.78712
		],
		"name": "Tampere"
	},
	{
		"latLng": [
			60.16952,
			24.93545
		],
		"name": "Helsinki"
	},
	{
		"latLng": [
			60.2052,
			24.6522
		],
		"name": "Espoo"
	},
	{
		"latLng": [
			43.60426,
			1.44367
		],
		"name": "Toulouse"
	},
	{
		"latLng": [
			48.58392,
			7.74553
		],
		"name": "Strasbourg"
	},
	{
		"latLng": [
			48.11198,
			-1.67429
		],
		"name": "Rennes"
	},
	{
		"latLng": [
			48.85341,
			2.3488
		],
		"name": "Paris"
	},
	{
		"latLng": [
			43.70313,
			7.26608
		],
		"name": "Nice"
	},
	{
		"latLng": [
			47.21725,
			-1.55336
		],
		"name": "Nantes"
	},
	{
		"latLng": [
			43.61092,
			3.87723
		],
		"name": "Montpellier"
	},
	{
		"latLng": [
			43.29695,
			5.38107
		],
		"name": "Marseille"
	},
	{
		"latLng": [
			45.74846,
			4.84671
		],
		"name": "Lyon"
	},
	{
		"latLng": [
			50.63297,
			3.05858
		],
		"name": "Lille"
	},
	{
		"latLng": [
			44.84044,
			-0.5805
		],
		"name": "Bordeaux"
	},
	{
		"latLng": [
			52.58547,
			-2.12296
		],
		"name": "Wolverhampton"
	},
	{
		"latLng": [
			53.00415,
			-2.18538
		],
		"name": "Stoke-on-Trent"
	},
	{
		"latLng": [
			51.53782,
			0.71433
		],
		"name": "Southend-on-Sea"
	},
	{
		"latLng": [
			50.90395,
			-1.40428
		],
		"name": "Southampton"
	},
	{
		"latLng": [
			53.38297,
			-1.4659
		],
		"name": "Sheffield"
	},
	{
		"latLng": [
			51.45625,
			-0.97113
		],
		"name": "Reading"
	},
	{
		"latLng": [
			53.76282,
			-2.70452
		],
		"name": "Preston"
	},
	{
		"latLng": [
			50.37153,
			-4.14305
		],
		"name": "Plymouth"
	},
	{
		"latLng": [
			52.9536,
			-1.15047
		],
		"name": "Nottingham"
	},
	{
		"latLng": [
			52.62783,
			1.29834
		],
		"name": "Norwich"
	},
	{
		"latLng": [
			52.25,
			-0.88333
		],
		"name": "Northampton"
	},
	{
		"latLng": [
			51.58774,
			-2.99835
		],
		"name": "Newport"
	},
	{
		"latLng": [
			52.04172,
			-0.75583
		],
		"name": "Milton Keynes"
	},
	{
		"latLng": [
			53.48095,
			-2.23743
		],
		"name": "Manchester"
	},
	{
		"latLng": [
			51.87967,
			-0.41748
		],
		"name": "Luton"
	},
	{
		"latLng": [
			51.50853,
			-0.12574
		],
		"name": "London"
	},
	{
		"latLng": [
			53.41058,
			-2.97794
		],
		"name": "Liverpool"
	},
	{
		"latLng": [
			52.6386,
			-1.13169
		],
		"name": "Leicester"
	},
	{
		"latLng": [
			53.79648,
			-1.54785
		],
		"name": "Leeds"
	},
	{
		"latLng": [
			53.7446,
			-0.33525
		],
		"name": "Kingston upon Hull"
	},
	{
		"latLng": [
			51.53622,
			-0.10304
		],
		"name": "Islington"
	},
	{
		"latLng": [
			51.48,
			-3.18
		],
		"name": "Cardiff"
	},
	{
		"latLng": [
			51.45523,
			-2.59665
		],
		"name": "Bristol"
	},
	{
		"latLng": [
			53.79391,
			-1.75206
		],
		"name": "Bradford"
	},
	{
		"latLng": [
			53.81667,
			-3.05
		],
		"name": "Blackpool"
	},
	{
		"latLng": [
			52.48142,
			-1.89983
		],
		"name": "Birmingham"
	},
	{
		"latLng": [
			53.39337,
			-3.01479
		],
		"name": "Birkenhead"
	},
	{
		"latLng": [
			51.44162,
			0.14866
		],
		"name": "Bexley"
	},
	{
		"latLng": [
			54.59682,
			-5.92541
		],
		"name": "Belfast"
	},
	{
		"latLng": [
			37.97945,
			23.71622
		],
		"name": "Athens"
	},
	{
		"latLng": [
			40.64361,
			22.93086
		],
		"name": "Thessaloníki"
	},
	{
		"latLng": [
			45.81444,
			15.97798
		],
		"name": "Zagreb"
	},
	{
		"latLng": [
			47.53333,
			21.63333
		],
		"name": "Debrecen"
	},
	{
		"latLng": [
			47.49801,
			19.03991
		],
		"name": "Budapest"
	},
	{
		"latLng": [
			53.33306,
			-6.24889
		],
		"name": "Dublin"
	},
	{
		"latLng": [
			38.13205,
			13.33561
		],
		"name": "Palermo"
	},
	{
		"latLng": [
			38.19394,
			15.55256
		],
		"name": "Messina"
	},
	{
		"latLng": [
			37.49223,
			15.07041
		],
		"name": "Catania"
	},
	{
		"latLng": [
			45.4299,
			10.98444
		],
		"name": "Verona"
	},
	{
		"latLng": [
			45.07049,
			7.68682
		],
		"name": "Turin"
	},
	{
		"latLng": [
			41.89193,
			12.51133
		],
		"name": "Rome"
	},
	{
		"latLng": [
			45.40797,
			11.88586
		],
		"name": "Padova"
	},
	{
		"latLng": [
			40.85216,
			14.26811
		],
		"name": "Naples"
	},
	{
		"latLng": [
			45.46427,
			9.18951
		],
		"name": "Milan"
	},
	{
		"latLng": [
			44.40478,
			8.94439
		],
		"name": "Genoa"
	},
	{
		"latLng": [
			43.77925,
			11.24626
		],
		"name": "Florence"
	},
	{
		"latLng": [
			44.49381,
			11.33875
		],
		"name": "Bologna"
	},
	{
		"latLng": [
			41.11148,
			16.8554
		],
		"name": "Bari"
	},
	{
		"latLng": [
			54.68916,
			25.2798
		],
		"name": "Vilnius"
	},
	{
		"latLng": [
			54.90272,
			23.90961
		],
		"name": "Kaunas"
	},
	{
		"latLng": [
			56.946,
			24.10589
		],
		"name": "Riga"
	},
	{
		"latLng": [
			52.09083,
			5.12222
		],
		"name": "Utrecht"
	},
	{
		"latLng": [
			52.07667,
			4.29861
		],
		"name": "The Hague"
	},
	{
		"latLng": [
			51.9225,
			4.47917
		],
		"name": "Rotterdam"
	},
	{
		"latLng": [
			51.44083,
			5.47778
		],
		"name": "Eindhoven"
	},
	{
		"latLng": [
			52.37403,
			4.88969
		],
		"name": "Amsterdam"
	},
	{
		"latLng": [
			52.22977,
			21.01178
		],
		"name": "Warsaw"
	},
	{
		"latLng": [
			51.40253,
			21.14714
		],
		"name": "Radom"
	},
	{
		"latLng": [
			52.1934,
			21.03487
		],
		"name": "Mokotów"
	},
	{
		"latLng": [
			51.25,
			22.56667
		],
		"name": "Lublin"
	},
	{
		"latLng": [
			50.87033,
			20.62752
		],
		"name": "Kielce"
	},
	{
		"latLng": [
			53.13333,
			23.16433
		],
		"name": "Białystok"
	},
	{
		"latLng": [
			51.1,
			17.03333
		],
		"name": "Wrocław"
	},
	{
		"latLng": [
			53.01375,
			18.59814
		],
		"name": "Toruń"
	},
	{
		"latLng": [
			53.42894,
			14.55302
		],
		"name": "Szczecin"
	},
	{
		"latLng": [
			50.28682,
			19.10385
		],
		"name": "Sosnowiec"
	},
	{
		"latLng": [
			52.40692,
			16.92993
		],
		"name": "Poznań"
	},
	{
		"latLng": [
			51.75,
			19.46667
		],
		"name": "Łódź"
	},
	{
		"latLng": [
			50.06143,
			19.93658
		],
		"name": "Kraków"
	},
	{
		"latLng": [
			50.25841,
			19.02754
		],
		"name": "Katowice"
	},
	{
		"latLng": [
			54.51889,
			18.53188
		],
		"name": "Gdynia"
	},
	{
		"latLng": [
			54.35205,
			18.64637
		],
		"name": "Gdańsk"
	},
	{
		"latLng": [
			50.79646,
			19.12409
		],
		"name": "Częstochowa"
	},
	{
		"latLng": [
			53.1235,
			18.00762
		],
		"name": "Bydgoszcz"
	},
	{
		"latLng": [
			38.71667,
			-9.13333
		],
		"name": "Lisbon"
	},
	{
		"latLng": [
			41.14961,
			-8.61099
		],
		"name": "Porto"
	},
	{
		"latLng": [
			45.75372,
			21.22571
		],
		"name": "Timişoara"
	},
	{
		"latLng": [
			44.95,
			26.01667
		],
		"name": "Ploieşti"
	},
	{
		"latLng": [
			47.0458,
			21.91833
		],
		"name": "Oradea"
	},
	{
		"latLng": [
			47.16667,
			27.6
		],
		"name": "Iaşi"
	},
	{
		"latLng": [
			45.45,
			28.05
		],
		"name": "Galaţi"
	},
	{
		"latLng": [
			44.31667,
			23.8
		],
		"name": "Craiova"
	},
	{
		"latLng": [
			44.18073,
			28.63432
		],
		"name": "Constanţa"
	},
	{
		"latLng": [
			46.76667,
			23.6
		],
		"name": "Cluj-Napoca"
	},
	{
		"latLng": [
			44.43225,
			26.10626
		],
		"name": "Bucharest"
	},
	{
		"latLng": [
			45.64861,
			25.60613
		],
		"name": "Braşov"
	},
	{
		"latLng": [
			45.26667,
			27.98333
		],
		"name": "Brăila"
	},
	{
		"latLng": [
			44.49239,
			26.04831
		],
		"name": "Sector 1"
	},
	{
		"latLng": [
			44.4528,
			26.13321
		],
		"name": "Sector 2"
	},
	{
		"latLng": [
			44.4234,
			26.16874
		],
		"name": "Sector 3"
	},
	{
		"latLng": [
			44.37571,
			26.12085
		],
		"name": "Sector 4"
	},
	{
		"latLng": [
			44.38808,
			26.07144
		],
		"name": "Sector 5"
	},
	{
		"latLng": [
			44.43579,
			26.01649
		],
		"name": "Sector 6"
	},
	{
		"latLng": [
			55.9825,
			37.18139
		],
		"name": "Zelenograd"
	},
	{
		"latLng": [
			56.63877,
			47.89078
		],
		"name": "Yoshkar-Ola"
	},
	{
		"latLng": [
			57.62987,
			39.87368
		],
		"name": "Yaroslavl"
	},
	{
		"latLng": [
			55.70196,
			37.81178
		],
		"name": "Vykhino-Zhulebino"
	},
	{
		"latLng": [
			51.67204,
			39.1843
		],
		"name": "Voronezh"
	},
	{
		"latLng": [
			48.78583,
			44.77973
		],
		"name": "Volzhskiy"
	},
	{
		"latLng": [
			59.2239,
			39.88398
		],
		"name": "Vologda"
	},
	{
		"latLng": [
			48.71939,
			44.50183
		],
		"name": "Volgograd"
	},
	{
		"latLng": [
			56.13655,
			40.39658
		],
		"name": "Vladimir"
	},
	{
		"latLng": [
			43.03667,
			44.66778
		],
		"name": "Vladikavkaz"
	},
	{
		"latLng": [
			54.32824,
			48.38657
		],
		"name": "Ulyanovsk"
	},
	{
		"latLng": [
			54.74306,
			55.96779
		],
		"name": "Ufa"
	},
	{
		"latLng": [
			56.85836,
			35.90057
		],
		"name": "Tver"
	},
	{
		"latLng": [
			54.19609,
			37.61822
		],
		"name": "Tula"
	},
	{
		"latLng": [
			53.5303,
			49.3461
		],
		"name": "Tol’yatti"
	},
	{
		"latLng": [
			52.73169,
			41.44326
		],
		"name": "Tambov"
	},
	{
		"latLng": [
			47.23617,
			38.89688
		],
		"name": "Taganrog"
	},
	{
		"latLng": [
			61.67642,
			50.80994
		],
		"name": "Syktyvkar"
	},
	{
		"latLng": [
			53.62462,
			55.95015
		],
		"name": "Sterlitamak"
	},
	{
		"latLng": [
			45.0428,
			41.9734
		],
		"name": "Stavropol’"
	},
	{
		"latLng": [
			51.29667,
			37.84167
		],
		"name": "Staryy Oskol"
	},
	{
		"latLng": [
			43.59917,
			39.72569
		],
		"name": "Sochi"
	},
	{
		"latLng": [
			54.7818,
			32.0401
		],
		"name": "Smolensk"
	},
	{
		"latLng": [
			47.70911,
			40.21443
		],
		"name": "Shakhty"
	},
	{
		"latLng": [
			51.54056,
			46.00861
		],
		"name": "Saratov"
	},
	{
		"latLng": [
			54.1838,
			45.1749
		],
		"name": "Saransk"
	},
	{
		"latLng": [
			59.93863,
			30.31413
		],
		"name": "Saint Petersburg"
	},
	{
		"latLng": [
			53.20007,
			50.15
		],
		"name": "Samara"
	},
	{
		"latLng": [
			58.0446,
			38.84259
		],
		"name": "Rybinsk"
	},
	{
		"latLng": [
			54.6269,
			39.6916
		],
		"name": "Ryazan’"
	},
	{
		"latLng": [
			47.23135,
			39.72328
		],
		"name": "Rostov-na-Donu"
	},
	{
		"latLng": [
			57.8136,
			28.3496
		],
		"name": "Pskov"
	},
	{
		"latLng": [
			61.78491,
			34.34691
		],
		"name": "Petrozavodsk"
	},
	{
		"latLng": [
			58.01046,
			56.25017
		],
		"name": "Perm"
	},
	{
		"latLng": [
			53.20066,
			45.00464
		],
		"name": "Penza"
	},
	{
		"latLng": [
			51.20487,
			58.56685
		],
		"name": "Orsk"
	},
	{
		"latLng": [
			51.7727,
			55.0988
		],
		"name": "Orenburg"
	},
	{
		"latLng": [
			52.96508,
			36.07849
		],
		"name": "Orël"
	},
	{
		"latLng": [
			44.72439,
			37.76752
		],
		"name": "Novorossiysk"
	},
	{
		"latLng": [
			58.52131,
			31.27104
		],
		"name": "Velikiy Novgorod"
	},
	{
		"latLng": [
			57.91944,
			59.965
		],
		"name": "Nizhniy Tagil"
	},
	{
		"latLng": [
			56.32867,
			44.00205
		],
		"name": "Nizhniy Novgorod"
	},
	{
		"latLng": [
			55.63657,
			51.82447
		],
		"name": "Nizhnekamsk"
	},
	{
		"latLng": [
			43.49806,
			43.61889
		],
		"name": "Nal’chik"
	},
	{
		"latLng": [
			55.72545,
			52.41122
		],
		"name": "Naberezhnyye Chelny"
	},
	{
		"latLng": [
			68.97917,
			33.09251
		],
		"name": "Murmansk"
	},
	{
		"latLng": [
			55.75222,
			37.61556
		],
		"name": "Moscow"
	},
	{
		"latLng": [
			55.65,
			37.71667
		],
		"name": "Mar’ino"
	},
	{
		"latLng": [
			42.97638,
			47.50236
		],
		"name": "Makhachkala"
	},
	{
		"latLng": [
			53.41861,
			59.04722
		],
		"name": "Magnitogorsk"
	},
	{
		"latLng": [
			52.60311,
			39.57076
		],
		"name": "Lipetsk"
	},
	{
		"latLng": [
			51.73733,
			36.18735
		],
		"name": "Kursk"
	},
	{
		"latLng": [
			45.04484,
			38.97603
		],
		"name": "Krasnodar"
	},
	{
		"latLng": [
			57.76647,
			40.92686
		],
		"name": "Kostroma"
	},
	{
		"latLng": [
			58.59665,
			49.66007
		],
		"name": "Kirov"
	},
	{
		"latLng": [
			55.89704,
			37.42969
		],
		"name": "Khimki"
	},
	{
		"latLng": [
			55.78874,
			49.12214
		],
		"name": "Kazan"
	},
	{
		"latLng": [
			54.5293,
			36.27542
		],
		"name": "Kaluga"
	},
	{
		"latLng": [
			54.70649,
			20.51095
		],
		"name": "Kaliningrad"
	},
	{
		"latLng": [
			56.84976,
			53.20448
		],
		"name": "Izhevsk"
	},
	{
		"latLng": [
			56.99719,
			40.97139
		],
		"name": "Ivanovo"
	},
	{
		"latLng": [
			43.31195,
			45.68895
		],
		"name": "Groznyy"
	},
	{
		"latLng": [
			56.24143,
			43.45539
		],
		"name": "Dzerzhinsk"
	},
	{
		"latLng": [
			59.13333,
			37.9
		],
		"name": "Cherepovets"
	},
	{
		"latLng": [
			56.13222,
			47.25194
		],
		"name": "Cheboksary"
	},
	{
		"latLng": [
			53.25209,
			34.37167
		],
		"name": "Bryansk"
	},
	{
		"latLng": [
			50.61074,
			36.58015
		],
		"name": "Belgorod"
	},
	{
		"latLng": [
			46.34968,
			48.04076
		],
		"name": "Astrakhan"
	},
	{
		"latLng": [
			64.5401,
			40.5433
		],
		"name": "Arkhangel’sk"
	},
	{
		"latLng": [
			56.8519,
			60.6122
		],
		"name": "Yekaterinburg"
	},
	{
		"latLng": [
			57.15222,
			65.52722
		],
		"name": "Tyumen"
	},
	{
		"latLng": [
			56.49771,
			84.97437
		],
		"name": "Tomsk"
	},
	{
		"latLng": [
			61.25,
			73.41667
		],
		"name": "Surgut"
	},
	{
		"latLng": [
			53.9059,
			86.719
		],
		"name": "Prokop’yevsk"
	},
	{
		"latLng": [
			54.99244,
			73.36859
		],
		"name": "Omsk"
	},
	{
		"latLng": [
			55.0415,
			82.9346
		],
		"name": "Novosibirsk"
	},
	{
		"latLng": [
			53.7557,
			87.1099
		],
		"name": "Novokuznetsk"
	},
	{
		"latLng": [
			60.9344,
			76.5531
		],
		"name": "Nizhnevartovsk"
	},
	{
		"latLng": [
			55.45,
			65.33333
		],
		"name": "Kurgan"
	},
	{
		"latLng": [
			56.01839,
			92.86717
		],
		"name": "Krasnoyarsk"
	},
	{
		"latLng": [
			55.33333,
			86.08333
		],
		"name": "Kemerovo"
	},
	{
		"latLng": [
			55.15402,
			61.42915
		],
		"name": "Chelyabinsk"
	},
	{
		"latLng": [
			52.53639,
			85.20722
		],
		"name": "Biysk"
	},
	{
		"latLng": [
			53.36056,
			83.76361
		],
		"name": "Barnaul"
	},
	{
		"latLng": [
			62.03389,
			129.73306
		],
		"name": "Yakutsk"
	},
	{
		"latLng": [
			43.10562,
			131.87353
		],
		"name": "Vladivostok"
	},
	{
		"latLng": [
			51.82721,
			107.60627
		],
		"name": "Ulan-Ude"
	},
	{
		"latLng": [
			50.55034,
			137.00995
		],
		"name": "Komsomolsk-on-Amur"
	},
	{
		"latLng": [
			48.48271,
			135.08379
		],
		"name": "Khabarovsk"
	},
	{
		"latLng": [
			52.29778,
			104.29639
		],
		"name": "Irkutsk"
	},
	{
		"latLng": [
			52.03171,
			113.50087
		],
		"name": "Chita"
	},
	{
		"latLng": [
			50.27961,
			127.5405
		],
		"name": "Blagoveshchensk"
	},
	{
		"latLng": [
			52.53667,
			103.88639
		],
		"name": "Angarsk"
	},
	{
		"latLng": [
			56.1325,
			101.61417
		],
		"name": "Bratsk"
	},
	{
		"latLng": [
			48.43776,
			135.13329
		],
		"name": "Khabarovsk Vtoroy"
	},
	{
		"latLng": [
			59.94091,
			30.25377
		],
		"name": "Vasyl'evsky Ostrov"
	},
	{
		"latLng": [
			59.99675,
			30.3899
		],
		"name": "Kalininskiy"
	},
	{
		"latLng": [
			59.97305,
			30.47607
		],
		"name": "Krasnogvargeisky"
	},
	{
		"latLng": [
			59.93111,
			30.36072
		],
		"name": "Centralniy"
	},
	{
		"latLng": [
			59.33258,
			18.0649
		],
		"name": "Stockholm"
	},
	{
		"latLng": [
			55.60587,
			13.00073
		],
		"name": "Malmö"
	},
	{
		"latLng": [
			57.70716,
			11.96679
		],
		"name": "Göteborg"
	},
	{
		"latLng": [
			46.05108,
			14.50513
		],
		"name": "Ljubljana"
	},
	{
		"latLng": [
			48.71395,
			21.25808
		],
		"name": "Košice"
	},
	{
		"latLng": [
			48.14816,
			17.10674
		],
		"name": "Bratislava"
	},
	{
		"latLng": [
			33.52066,
			-86.80249
		],
		"name": "Birmingham"
	},
	{
		"latLng": [
			32.36681,
			-86.29997
		],
		"name": "Montgomery"
	},
	{
		"latLng": [
			38.89511,
			-77.03637
		],
		"name": "Washington, D.C."
	},
	{
		"latLng": [
			25.8576,
			-80.27811
		],
		"name": "Hialeah"
	},
	{
		"latLng": [
			30.33218,
			-81.65565
		],
		"name": "Jacksonville"
	},
	{
		"latLng": [
			25.77427,
			-80.19366
		],
		"name": "Miami"
	},
	{
		"latLng": [
			28.53834,
			-81.37924
		],
		"name": "Orlando"
	},
	{
		"latLng": [
			27.77086,
			-82.67927
		],
		"name": "St. Petersburg"
	},
	{
		"latLng": [
			27.94752,
			-82.45843
		],
		"name": "Tampa"
	},
	{
		"latLng": [
			33.749,
			-84.38798
		],
		"name": "Atlanta"
	},
	{
		"latLng": [
			32.46098,
			-84.98771
		],
		"name": "Columbus"
	},
	{
		"latLng": [
			39.76838,
			-86.15804
		],
		"name": "Indianapolis"
	},
	{
		"latLng": [
			37.69224,
			-97.33754
		],
		"name": "Wichita"
	},
	{
		"latLng": [
			38.45647,
			-82.69238
		],
		"name": "Ironville"
	},
	{
		"latLng": [
			37.98869,
			-84.47772
		],
		"name": "Lexington"
	},
	{
		"latLng": [
			38.0498,
			-84.45855
		],
		"name": "Lexington-Fayette"
	},
	{
		"latLng": [
			38.25424,
			-85.75941
		],
		"name": "Louisville"
	},
	{
		"latLng": [
			38.41258,
			-82.70905
		],
		"name": "Meads"
	},
	{
		"latLng": [
			30.45075,
			-91.15455
		],
		"name": "Baton Rouge"
	},
	{
		"latLng": [
			29.95465,
			-90.07507
		],
		"name": "New Orleans"
	},
	{
		"latLng": [
			39.29038,
			-76.61219
		],
		"name": "Baltimore"
	},
	{
		"latLng": [
			39.09973,
			-94.57857
		],
		"name": "Kansas City"
	},
	{
		"latLng": [
			38.62727,
			-90.19789
		],
		"name": "St. Louis"
	},
	{
		"latLng": [
			35.22709,
			-80.84313
		],
		"name": "Charlotte"
	},
	{
		"latLng": [
			35.99403,
			-78.89862
		],
		"name": "Durham"
	},
	{
		"latLng": [
			35.05266,
			-78.87836
		],
		"name": "Fayetteville"
	},
	{
		"latLng": [
			36.07264,
			-79.79198
		],
		"name": "Greensboro"
	},
	{
		"latLng": [
			35.7721,
			-78.63861
		],
		"name": "Raleigh"
	},
	{
		"latLng": [
			35.78682,
			-78.66389
		],
		"name": "West Raleigh"
	},
	{
		"latLng": [
			36.09986,
			-80.24422
		],
		"name": "Winston-Salem"
	},
	{
		"latLng": [
			39.12711,
			-84.51439
		],
		"name": "Cincinnati"
	},
	{
		"latLng": [
			39.96118,
			-82.99879
		],
		"name": "Columbus"
	},
	{
		"latLng": [
			35.46756,
			-97.51643
		],
		"name": "Oklahoma City"
	},
	{
		"latLng": [
			36.15398,
			-95.99277
		],
		"name": "Tulsa"
	},
	{
		"latLng": [
			39.95233,
			-75.16379
		],
		"name": "Philadelphia"
	},
	{
		"latLng": [
			35.14953,
			-90.04898
		],
		"name": "Memphis"
	},
	{
		"latLng": [
			36.16589,
			-86.78444
		],
		"name": "Nashville"
	},
	{
		"latLng": [
			35.08676,
			-90.05676
		],
		"name": "New South Memphis"
	},
	{
		"latLng": [
			32.73569,
			-97.10807
		],
		"name": "Arlington"
	},
	{
		"latLng": [
			30.26715,
			-97.74306
		],
		"name": "Austin"
	},
	{
		"latLng": [
			27.80058,
			-97.39638
		],
		"name": "Corpus Christi"
	},
	{
		"latLng": [
			32.78306,
			-96.80667
		],
		"name": "Dallas"
	},
	{
		"latLng": [
			32.72541,
			-97.32085
		],
		"name": "Fort Worth"
	},
	{
		"latLng": [
			32.91262,
			-96.63888
		],
		"name": "Garland"
	},
	{
		"latLng": [
			29.76328,
			-95.36327
		],
		"name": "Houston"
	},
	{
		"latLng": [
			41.60054,
			-93.60911
		],
		"name": "Des Moines"
	},
	{
		"latLng": [
			41.76058,
			-88.32007
		],
		"name": "Aurora"
	},
	{
		"latLng": [
			41.85003,
			-87.65005
		],
		"name": "Chicago"
	},
	{
		"latLng": [
			41.1306,
			-85.12886
		],
		"name": "Fort Wayne"
	},
	{
		"latLng": [
			42.35843,
			-71.05977
		],
		"name": "Boston"
	},
	{
		"latLng": [
			42.33343,
			-71.04949
		],
		"name": "South Boston"
	},
	{
		"latLng": [
			42.33143,
			-83.04575
		],
		"name": "Detroit"
	},
	{
		"latLng": [
			44.97997,
			-93.26384
		],
		"name": "Minneapolis"
	},
	{
		"latLng": [
			44.94441,
			-93.09327
		],
		"name": "Saint Paul"
	},
	{
		"latLng": [
			40.8,
			-96.66696
		],
		"name": "Lincoln"
	},
	{
		"latLng": [
			41.25626,
			-95.94043
		],
		"name": "Omaha"
	},
	{
		"latLng": [
			40.72816,
			-74.07764
		],
		"name": "Jersey City"
	},
	{
		"latLng": [
			40.73566,
			-74.17237
		],
		"name": "Newark"
	},
	{
		"latLng": [
			40.84985,
			-73.86641
		],
		"name": "The Bronx"
	},
	{
		"latLng": [
			40.6501,
			-73.94958
		],
		"name": "Brooklyn"
	},
	{
		"latLng": [
			42.88645,
			-78.87837
		],
		"name": "Buffalo"
	},
	{
		"latLng": [
			40.69149,
			-73.80569
		],
		"name": "Jamaica"
	},
	{
		"latLng": [
			40.78343,
			-73.96625
		],
		"name": "Manhattan"
	},
	{
		"latLng": [
			40.71427,
			-74.00597
		],
		"name": "New York City"
	},
	{
		"latLng": [
			40.68149,
			-73.83652
		],
		"name": "Queens"
	},
	{
		"latLng": [
			43.15478,
			-77.61556
		],
		"name": "Rochester"
	},
	{
		"latLng": [
			40.56233,
			-74.13986
		],
		"name": "Staten Island"
	},
	{
		"latLng": [
			40.93121,
			-73.89875
		],
		"name": "Yonkers"
	},
	{
		"latLng": [
			41.4995,
			-81.69541
		],
		"name": "Cleveland"
	},
	{
		"latLng": [
			41.66394,
			-83.55521
		],
		"name": "Toledo"
	},
	{
		"latLng": [
			40.44062,
			-79.99589
		],
		"name": "Pittsburgh"
	},
	{
		"latLng": [
			43.07305,
			-89.40123
		],
		"name": "Madison"
	},
	{
		"latLng": [
			43.0389,
			-87.90647
		],
		"name": "Milwaukee"
	},
	{
		"latLng": [
			33.30616,
			-111.84125
		],
		"name": "Chandler"
	},
	{
		"latLng": [
			33.35283,
			-111.78903
		],
		"name": "Gilbert"
	},
	{
		"latLng": [
			33.53865,
			-112.18599
		],
		"name": "Glendale"
	},
	{
		"latLng": [
			33.42227,
			-111.82264
		],
		"name": "Mesa"
	},
	{
		"latLng": [
			33.44838,
			-112.07404
		],
		"name": "Phoenix"
	},
	{
		"latLng": [
			33.50921,
			-111.89903
		],
		"name": "Scottsdale"
	},
	{
		"latLng": [
			32.22174,
			-110.92648
		],
		"name": "Tucson"
	},
	{
		"latLng": [
			33.83529,
			-117.9145
		],
		"name": "Anaheim"
	},
	{
		"latLng": [
			35.37329,
			-119.01871
		],
		"name": "Bakersfield"
	},
	{
		"latLng": [
			32.64005,
			-117.0842
		],
		"name": "Chula Vista"
	},
	{
		"latLng": [
			34.09223,
			-117.43505
		],
		"name": "Fontana"
	},
	{
		"latLng": [
			37.54827,
			-121.98857
		],
		"name": "Fremont"
	},
	{
		"latLng": [
			36.74773,
			-119.77237
		],
		"name": "Fresno"
	},
	{
		"latLng": [
			34.14251,
			-118.25508
		],
		"name": "Glendale"
	},
	{
		"latLng": [
			33.6603,
			-117.99923
		],
		"name": "Huntington Beach"
	},
	{
		"latLng": [
			33.76696,
			-118.18923
		],
		"name": "Long Beach"
	},
	{
		"latLng": [
			34.05223,
			-118.24368
		],
		"name": "Los Angeles"
	},
	{
		"latLng": [
			37.6391,
			-120.99688
		],
		"name": "Modesto"
	},
	{
		"latLng": [
			33.93752,
			-117.23059
		],
		"name": "Moreno Valley"
	},
	{
		"latLng": [
			34.16056,
			-118.26452
		],
		"name": "North Glendale"
	},
	{
		"latLng": [
			37.80437,
			-122.2708
		],
		"name": "Oakland"
	},
	{
		"latLng": [
			34.1975,
			-119.17705
		],
		"name": "Oxnard"
	},
	{
		"latLng": [
			33.95335,
			-117.39616
		],
		"name": "Riverside"
	},
	{
		"latLng": [
			38.58157,
			-121.4944
		],
		"name": "Sacramento"
	},
	{
		"latLng": [
			34.10834,
			-117.28977
		],
		"name": "San Bernardino"
	},
	{
		"latLng": [
			32.71533,
			-117.15726
		],
		"name": "San Diego"
	},
	{
		"latLng": [
			37.77493,
			-122.41942
		],
		"name": "San Francisco"
	},
	{
		"latLng": [
			37.33939,
			-121.89496
		],
		"name": "San Jose"
	},
	{
		"latLng": [
			33.74557,
			-117.86783
		],
		"name": "Santa Ana"
	},
	{
		"latLng": [
			37.9577,
			-121.29078
		],
		"name": "Stockton"
	},
	{
		"latLng": [
			39.72943,
			-104.83192
		],
		"name": "Aurora"
	},
	{
		"latLng": [
			38.83388,
			-104.82136
		],
		"name": "Colorado Springs"
	},
	{
		"latLng": [
			39.73915,
			-104.9847
		],
		"name": "Denver"
	},
	{
		"latLng": [
			35.08449,
			-106.65114
		],
		"name": "Albuquerque"
	},
	{
		"latLng": [
			36.0397,
			-114.98194
		],
		"name": "Henderson"
	},
	{
		"latLng": [
			36.17497,
			-115.13722
		],
		"name": "Las Vegas"
	},
	{
		"latLng": [
			36.19886,
			-115.1175
		],
		"name": "North Las Vegas"
	},
	{
		"latLng": [
			36.09719,
			-115.14666
		],
		"name": "Paradise"
	},
	{
		"latLng": [
			39.52963,
			-119.8138
		],
		"name": "Reno"
	},
	{
		"latLng": [
			31.75872,
			-106.48693
		],
		"name": "El Paso"
	},
	{
		"latLng": [
			33.57786,
			-101.85517
		],
		"name": "Lubbock"
	},
	{
		"latLng": [
			45.52345,
			-122.67621
		],
		"name": "Portland"
	},
	{
		"latLng": [
			47.60621,
			-122.33207
		],
		"name": "Seattle"
	},
	{
		"latLng": [
			47.65966,
			-117.42908
		],
		"name": "Spokane"
	},
	{
		"latLng": [
			47.25288,
			-122.44429
		],
		"name": "Tacoma"
	},
	{
		"latLng": [
			21.30694,
			-157.85833
		],
		"name": "Honolulu"
	},
	{
		"latLng": [
			61.21806,
			-149.90028
		],
		"name": "Anchorage"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/util/cities.json
// module id = 988
// module chunks = 0